module.exports = __webpack_public_path__ + "img/insure2.db9cd28e.png";